<template>
  <div>
    <b-row class="mb-1">
      
      <b-col cols="10">
        <b-card border-variant="success" no-body class="mb-2">
          <b-row v-if="messagesStatus.getAllMessages" class="text-center mb-3">
            <b-spinner variant="success" type="grow"  class="text-center"></b-spinner>
          </b-row>

          <b-row v-else-if="messages.length === 0" class="my-4 mx-1">
            <b-col>
              <b-alert variant="success" class="mb-0 py-3" show><h4>Keine Nachrichten</h4></b-alert>
            </b-col>
          </b-row>

          <div v-else-if="messages.length > 0" class="text-left">
            <b-card-header header-bg-variant="success" class="py-1 px-1">
              <div v-if="messages[i].gelesen === 0" class="bg-warning float-right text-warning rounded-circle small ml-2">aa</div>
              <b-card-title class="text-white mb-0 p-0">{{messages[i].fromName}} <font-awesome-icon icon="cog" class=" float-right ml-2 grow" @click="$bvModal.show(`message-update`)"/> <small class="float-right text-white">{{ aDate }}</small></b-card-title>
            </b-card-header>

            <b-row>
              <b-col cols="6" v-if="messages[i].hasAttachment == 1 && messages[i].image != null" v-b-modal.message-image-modal>
                <img class="card-img" :src="`data:${messages[i].image.contentType};base64,${messages[i].image.image}`" />
              </b-col>

              <b-col cols="6">
                <b-card-body class="p-0 messageBody">
                  <p class="p-1 pre-formatted">{{messages[i].content}}</p>
                </b-card-body>
              </b-col>
            </b-row>
          </div>
        </b-card>
      </b-col>

      <b-col class="text-center">
        <b-button variant="info" class="mb-5" @click="nextMessage">
          <b-spinner v-if="messagesStatus.getNewMessages" class="text-center mx-2 icon-size"></b-spinner>
          <font-awesome-icon v-else icon="arrow-up" class="text-white mx-2 icon-size grow" />
        </b-button>
        <b-button variant="info" class="mb-4" @click="prevMessage" v-bind:disabled="lastMessage"><font-awesome-icon icon="arrow-down" class="text-white mx-2 icon-size grow" /></b-button>

        <p>{{ i+1 }} / {{ messages.length }}</p>
      </b-col>
    </b-row>

    <div v-if="messages.length > 0">
      <b-modal v-if="messages[i].hasAttachment == 1 && messages[i].image != null" id="message-image-modal" class="modal-fullscreen"  hide-header hide-footer>
        <img :src="`data:${messages[i].image.contentType};base64,${messages[i].image.image}`" @click="closeImageModal" class="modal-full-img" />
      </b-modal>

      <b-modal id="message-update" size="xl" header-bg-variant="success" header-text-variant="white" hide-footer>
        <b-button variant="danger" @click="removeMessage()" class="mr-3">Löschen</b-button>
        <b-button variant="secondary" @click="$bvModal.hide(`message-update`)">Abbrechen</b-button>
      </b-modal>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import moment from 'moment'

export default {
  name: 'MessagesCard',
  computed: {
    ...mapGetters(['messagesStatus', 'messages']),
    lastMessage() {
      return (this.i === this.messages.length - 1 || this.i === this.messages.length)
    },
    aDate () {
      return moment(this.messages[this.i].aDate).format('DD.MM.YYYY HH:mm:ss')
    }
  },
  methods: {
    ...mapActions(['getAllMessages', 'getNewMessages', 'deleteMessage', 'updateMessage']),
    closeImageModal () {
      this.$bvModal.hide(`message-image-modal`)
    },
    prevMessage() {
      if(this.messages[this.i].gelesen === 0) {
        this.messages[this.i].gelesen = 1
        this.updateMessage(this.messages[this.i])
      }

      if (this.i < this.messages.length - 1) {
        this.i++
      }
    },
    nextMessage() {
      if(this.messages.length > 0 && this.messages[this.i].gelesen === 0) {
        this.messages[this.i].gelesen = 1
        this.updateMessage(this.messages[this.i])
      }

      if (this.i > 0) {
        this.i--
      }
      else if (this.i === 0) {
        var length = this.messages.length
        this.getNewMessages()
          .then(() => {
            if (!this.messagesStatus.noNewMessages) {
              this.i = this.messages.length - length - 1
            }

            const toastData = {
              title: "Neue Nachrichten empfangen",
              msg: "...",
              variant: "success"
              }

            if (this.messagesStatus.noNewMessages) {
              toastData.title= "Keine neuen Nachrichten"
              toastData.msg = "..."
            }

            if (this.messagesStatus.errMsg) {
              toastData.title = "Es ist etwas schief gelaufen.";
              // toastData.msg = this.benutzerStatus.errMsg;
              toastData.msg = "...";
              toastData.variant = "danger";
            }

            this.$emit('messagesToast', toastData)
          })
      }
      else {
        this.i = 0;
      }
    },
    removeMessage() {
      if (confirm("Wollen Sie die Nachricht wirklich löschen?")) {
        const messageId = this.messages[this.i].id
        this.i > 0 ? this.i-- : this.i = 0

        this.deleteMessage(messageId)
          .then(() => {
            const toastData = {
              title: "Die Nachricht wurde gelöscht",
              msg: "...",
              variant: "success"
              }

            if (this.messagesStatus.errMsg) {
              toastData.title = "Es ist etwas schief gelaufen.";
              // toastData.msg = this.benutzerStatus.errMsg;
              toastData.msg = "...";
              toastData.variant = "danger";
            } else {
              this.$bvModal.hide(`message-update`)
            }

            this.$emit('messagesToast', toastData)
          })
        
        
      }
    }
  },
  data () {
    return {
      i: 0
    }
  },
  mounted () {
    if (this.messages.length === 0) {
      this.getAllMessages()
    }
  }
}
</script>

<style scoped>
.messageBody {
  min-height: 12rem;
  font-size: 1.5em;
}

.grow {
  transition: all .2s ease-in-out;
}

.grow:hover {
  cursor: pointer;
  transform: scale(1.1);
}

.icon-size {
  font-size: 5em
}

.pre-formatted {
  white-space: pre;
}

.modal-full-img {
  padding: 0;
  margin: 0 auto;
  height: auto;
  /* max-height: 94vh; */
  width: 100%;
  max-width: 94vw;
}
</style>


<style lang="scss" scoped>

::v-deep #message-image-modal > .modal-dialog {
  width: 94%;
  max-width: 94%;
}

::v-deep #message-image-modal > .modal-dialog > .modal-content > .modal-body {
  padding: 0 !important;
}
</style>